<template>
	<md-button class="md-icon-button md-danger px-2 w-16" @click="getTrendPdf">
		<span v-if="!loading" class="font-medium">{{ year }}</span>
		<font-awesome-icon v-else class="md-icon animate-spin" :icon="['fa', 'sync-alt']">{{ year }}</font-awesome-icon>
	</md-button>
</template>

<script>
export default {
	name: "PdfTrendButton",
	props: {
		year: String,
		siteId: Number
	},
	data() {
		return {
			loading: false
		}
	},
	methods: {
		async getTrendPdf() {
			this.loading = true
			try {
				const localStorageData = JSON.parse(localStorage.getItem('client-area'))
				const { data } = await this.$store.dispatch('clientArea/getTrendPdf', {
						access_token: localStorageData.accessToken,
						user_type: localStorageData.userType,
						year: this.year,
						siteId: this.siteId
					}
				)
				let link = document.createElement('a')
				link.setAttribute('href', data)
				link.setAttribute('target', '_blank')
				link.click()
			} catch (e) {}
			this.loading = false
		},
	}
}
</script>

<style scoped>

</style>
